import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import {HiArrowDown} from "react-icons/hi2";

export default function SectionStartOutcome(){

    const IMG_PADDING = 12;

    const TextParallaxContent = ({ imgUrl, subheading, heading, children }) => {
        return (
            <div
                style={{
                    paddingLeft: IMG_PADDING,
                    paddingRight: IMG_PADDING,
                }}
            >
                <div className="relative h-[150vh]">
                    <StickyImage imgUrl={imgUrl} />
                    <OverlayCopy heading={heading} subheading={subheading} />
                </div>
                {children}
            </div>
        );
    };

    const StickyImage = ({ imgUrl }) => {
        const targetRef = useRef(null);
        const { scrollYProgress } = useScroll({
            target: targetRef,
            offset: ["end end", "end start"],
        });

        const scale = useTransform(scrollYProgress, [0, 1], [1, 0.85]);
        const opacity = useTransform(scrollYProgress, [0, 0.7], [1, 0]);

        return (
            <motion.div
                style={{
                    backgroundImage: `url(${imgUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: `calc(100vh - ${IMG_PADDING * 2}px)`,
                    top: IMG_PADDING,
                    scale,
                }}
                ref={targetRef}
                className="sticky z-0 overflow-hidden rounded-3xl"
            >
                <motion.div
                    className="absolute inset-0 bg-blue-600/60"
                    style={{
                        opacity,
                    }}
                />
            </motion.div>
        );
    };

    const OverlayCopy = ({ subheading, heading }) => {
        const targetRef = useRef(null);
        const { scrollYProgress } = useScroll({
            target: targetRef,
            offset: ["start end", "end start"],
        });

        const y = useTransform(scrollYProgress, [0, 1], [250, -250]);
        const opacity = useTransform(scrollYProgress, [0.25, 0.5, 0.75], [0, 1, 0]);

        return (
            <motion.div
                style={{
                    y,
                    opacity,
                }}
                ref={targetRef}
                className="absolute left-0 top-0 flex h-screen w-full flex-col items-center justify-center text-white"
            >
                <p className="mb-2 text-center text-xl md:mb-4 md:text-3xl">
                    {subheading}
                </p>
                <p className="text-center text-4xl font-bold md:text-7xl">{heading}</p>
            </motion.div>
        );
    };

    const ExampleContent = () => (
        <div>
            <div className="mx-auto grid max-w-5xl grid-cols-1 gap-8 px-4 pb-12 pt-12 md:grid-cols-12">
                <motion.div
                    className="col-span-1 text-3xl font-bold md:col-span-4 text-blue-600"
                    variants={{
                        hidden: { opacity: 0, x: -50 },
                        visible: { opacity: 1, x: 0 }
                    }}
                    initial="hidden"
                    whileInView="visible"
                    transition={{duration: 0.6, delay: 0.4}}
                    viewport={{once: false}}
                >
                    Additional content explaining the above card here
                </motion.div>
                <motion.div
                    className="col-span-1 md:col-span-8"
                    variants={{
                        hidden: { opacity: 0, x: 50 },
                        visible: { opacity: 1, x: 0 }
                    }}
                    initial="hidden"
                    whileInView="visible"
                    transition={{duration: 0.6, delay: 0.4}}
                    viewport={{once: false}}
                >
                    <p className="mb-4 text-xl text-neutral-600 md:text-2xl">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi,
                        blanditiis soluta eius quam modi aliquam quaerat odit deleniti minima
                        maiores voluptate est ut saepe accusantium maxime doloremque nulla
                        consectetur possimus.
                    </p>
                    <p className="mb-8 text-xl text-neutral-600 md:text-2xl">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium
                        reiciendis blanditiis aliquam aut fugit sint.
                    </p>
                </motion.div>
            </div>
            <motion.div
                variants={{
                    hidden: { opacity: 0, y: -50 },
                    visible: { opacity: 1, y: 0 }
                }}
                initial="hidden"
                whileInView="visible"
                transition={{duration: 0.6, delay: 0.4}}
                viewport={{once: false}}
            >
                <HiArrowDown className="text-6xl mx-auto"  />
            </motion.div>
        </div>
    );

    return(
        <div>
            <div>
                <div className="bg-white">
                    <TextParallaxContent
                        imgUrl="https://dummyimage.com/1000x800/F5F5F5"
                        subheading="Outcome"
                        heading="The result and value of our project."
                    >
                        <ExampleContent />
                    </TextParallaxContent>
                </div>
            </div>
        </div>
    )
}